import React, { useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { useGetPaymentOrderStatsQuery, useGetTransactionsForRestaurantQuery } from '../../redux/services/dashboardService';
import BreadCrumbs from '../../components/BreadCrumbs';
import ButtonComponent from '../../components/ButtonComponent';
import Graph from '../../components/Graph';
import { PAYOUTS_PAYMENTS_NAME } from '../../constants/constans';
import { DateRangePicker } from 'react-date-range-ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import PaymentStatusBox from '../../components/PaymentStatusBox';
import BreakDownAccordion from '../../components/BreakDownAccordian';
import { format } from "date-fns";
import { setSelectedRestaurantDetails } from '../../redux/restaurantsSlice';
import ReastaurantSlectModal from '../../components/ReastaurantSlectModal';
import './index.css';
import "react-date-range-ts/dist/styles.css";
import "react-date-range-ts/dist/theme/default.css";
import { Card, Alert, Col, Placeholder, Row } from "react-bootstrap";
import TableLoadingComponent from '../../components/TableLoadingComponent';
import { useRestaurantDetails } from '../../hooks/useFirebaseOrders';

const Home = () => {
  const dispatch = useDispatch();
  
  const isSelectRestaurant = useSelector((state: any) => state?.restaurant?.isInitialSlectReastaurant
  );

  const RestID = useSelector(
    (state: any) => state.restaurant.selectedRestaurantDetails?.id || ""
  );

  const [openDate, setOpenDate] = useState(false);
  const [date, setDate] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const datePickerRef = useRef<HTMLDivElement>(null);

  const handleChange = (ranges: any) => {
    setDate(ranges.selection);
  };

  const handleClick = () => {
    setOpenDate((prev) => !prev);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      datePickerRef.current &&
      !datePickerRef.current.contains(event.target as Node)
    ) {
      setOpenDate(false);
    }
  };

  // Add and clean up the click event listener
  useEffect(() => {
    if (openDate) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDate]);

  // Set today's date as default on component mount
  useEffect(() => {
    const today = new Date();
    setDate({
      startDate: today,
      endDate: today,
      key: "selection",
    });
  }, []);

  // Convert date to the required format (ISO 8601)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const today = new Date();

  const isSameDay = date.startDate.getTime() === date.endDate.getTime();

  const startDate = new Date(date.startDate);
  if (isSameDay) {
    startDate.setUTCHours(0, 0, 0, 0);
  } else {
    startDate.setUTCHours(0, 0, 0, 0);
    startDate.setUTCDate(startDate.getUTCDate() + 1);
  }

  // Handle the end date
  const endDate = new Date(date.endDate);
  if (isSameDay) {
    endDate.setUTCHours(23, 59, 59, 999);
  } else {
    endDate.setUTCHours(23, 59, 59, 999);
  }
  const formattedStartDate = startDate.toISOString();
  const formattedEndDate = endDate.toISOString();

  const { data, isLoading, error } = useGetPaymentOrderStatsQuery({
    restaurantId: RestID,
    startDate: formattedStartDate,
    endDate: formattedEndDate,
  });

  const {
    data: transactionsData,
    isLoading: isTransactionsLoading,
    error: transactionsError,
  } = useGetTransactionsForRestaurantQuery({
    restaurantId: RestID,
    startDate: formattedStartDate,
    endDate: formattedEndDate,
  });

  useEffect(() => {
    if (transactionsData) {
    }
  }, [transactionsData]);

  const {data: restaurantDetails} =
    useRestaurantDetails(RestID);

  // Dispatch restaurant details to Redux store when they're loaded
  useEffect(() => {
    if (restaurantDetails) {
      dispatch(setSelectedRestaurantDetails(restaurantDetails));
    }
  }, [restaurantDetails, dispatch]);

  // useEffect(() => {
  //   if (selectedRestaurantId) {
  //     trigger(selectedRestaurantId);
  //   }
  // }, [selectedRestaurantId, trigger]);

  return (
    <div className="payouts-container">
      {!isSelectRestaurant && <ReastaurantSlectModal />}
      <BreadCrumbs hasSubMenus={false} />
      <div className="d-flex justify-content-end align-items-center">
      </div>
      <div className="paymentsGraphBox">
        <div className="paymentGraphBoxUpperLine">
          <h3 className='mt-3 mb-3'>Sales Report</h3>
          <ButtonComponent titel="View Report" />
        </div>
        <div className='pt-3'>
          <Graph />
        </div>
      </div>
      <div className="payouts-header">
        <h2 className="payouts-title">{PAYOUTS_PAYMENTS_NAME}</h2>
        <div className="payouts-content">
          <div className="date-picker-container px-5" ref={datePickerRef}>
            <input
              className="payouts-input"
              onClick={handleClick}
              placeholder={`${format(
                date.startDate,
                "MMM, dd, yyyy"
              )} - ${format(date.endDate, "MMM, dd, yyyy")}`}
            />
            {openDate && (
              <div className="date-picker-content">
                <div className="calendar-section">
                  <DateRangePicker
                    ranges={[date]}
                    onChange={handleChange}
                    className="dateRange"
                    inputRanges={[]}
                  />
                </div>
              </div>
            )}
          </div>
          <div className="mx-2">
            <ButtonComponent
              icon={<FontAwesomeIcon icon={faDownload} />}
              titel="Download"
            />
          </div>
        </div>
      </div>
      <div className="paymentStatusBoxStyling">
        {isLoading ? (
          // <div className="d-flex justify-content-center"><LoadingMessage /></div>
          <>
            <Row className="g-5">
              {[...Array(4)].map((_, index) => (
                <Col key={index} md={3}>
                  <Card>
                    <Card.Body style={{width:"250px",height:"150px"}} className='d-flex flex-column justify-content-center'>
                      <Placeholder as={Card.Title} animation="wave">
                        <Placeholder xs={6} />
                      </Placeholder>
                      <Placeholder as={Card.Text} animation="wave">
                        <Placeholder xs={8} />
                        <Placeholder xs={4} />
                      </Placeholder>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row></>
        ) : error ? (
          <Alert variant="danger">Error loading data</Alert>
        ) : (
          <>
            <PaymentStatusBox
              title="Total Orders"
              value={data?.totalCounts?.allOrderCount?.toString() || "0"}
            />
            <PaymentStatusBox
              title="Total Payout"
              value={data?.totalCounts?.totalPayout?.toString() || "0"}
            />
            <PaymentStatusBox
              title="Customer Count"
              value={data?.totalCounts?.customerCount?.toString() || "0"}
            />
            <PaymentStatusBox title="Customer Refunds" value={data?.totalCounts?.customerRefunds?.toString() || "0"} />
          </>
        )}
      </div>
      <div className="payBreakDownBox">
        <h3>Pay Breakdown</h3>
        {isTransactionsLoading ? (
          <><TableLoadingComponent numColumns={2}/></>
        ) : transactionsError ? (
          <Alert variant="danger">Error loading data</Alert>
        ) : (
          transactionsData && (
            <BreakDownAccordion
              curryKingFeesTotal={
                transactionsData.transactionsList.CurryKingFees?.totalAmount ||
                0
              }
              otherPaymentsTotal={
                transactionsData.transactionsList.OtherPayments?.totalAmount ||
                0
              }
              cartCommissionsTotal={
                transactionsData.transactionsList.CartCommissions
                  ?.totalAmount || 0
              }
              salesTotal={
                transactionsData.transactionsList.Sales?.totalAmount || 0
              }
              refundsTotal={
                transactionsData.transactionsList.Refund?.totalAmount || 0
              }
              // myEarningsTotal={
              //   transactionsData.transactionsList.Earnings?.totalAmount || 0
              // }
              marketingSpendTotal={
                transactionsData.transactionsList.MarketingSpend?.totalAmount ||
                0
              }

              refundsTransactions={
                transactionsData.transactionsList.Refund?.transactions || []
              }
              earningsTransactions={
                transactionsData.transactionsList.Earnings?.transactions || []
              }
              marketingSpendTransactions={
                transactionsData.transactionsList.MarketingSpend
                  ?.transactions || []
              }
              curryKingFeesTransactions={
                transactionsData.transactionsList.CurryKingFees?.transactions ||
                []
              }
              cartCommissionsTransactions={
                transactionsData.transactionsList.CartCommissions
                  ?.transactions || []
              }
              salesTransactions={
                transactionsData.transactionsList.Sales?.transactions || []
              }
              otherPaymentsTransactions={
                transactionsData.transactionsList.OtherPayments?.transactions ||
                []
              }
            />
          )
        )}
      </div>
    </div>
  );
}

export default Home;